/**
 * In dev mode, rewrite absolute wss:// URL through the Vite dev server proxy
 * so the phone doesn't need direct VPN access to the game engine.
 */
export const rewriteWsUrlForDevProxy = (url: string): string => {
  if (!import.meta.env.DEV || import.meta.env.VITE_DEV_PROXY_ENABLED !== 'true') return url;

  try {
    const parsed = new URL(url);
    const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const encodedHost = encodeURIComponent(parsed.host);
    return `${scheme}://${window.location.host}/ws-proxy/${encodedHost}${parsed.pathname}${parsed.search}`;
  } catch {
    return url;
  }
};
